module.exports = __webpack_public_path__ + "ionicons.24712f6c47821394fba7.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/ionicons.ttf
// module id = ../../../../../src/assets/fonts/ionicons.ttf
// module chunks = styles